/** Даты и время: ISO 8601 (UTC на сервере, локальная зона пользователя в UI). */

export function toDateInputValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayInputValue(): string {
  return toDateInputValue(new Date());
}

export function addDaysInputValue(days: number, from = new Date()): string {
  const date = new Date(from.getTime());
  date.setDate(date.getDate() + days);
  return toDateInputValue(date);
}

export function formatDateTimeLocal(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('ru-RU', { dateStyle: 'medium', timeStyle: 'short' });
}

export function formatPercent(ratio: number | null | undefined): string {
  if (typeof ratio !== 'number' || Number.isNaN(ratio)) return '—';
  const percent = ratio <= 1 ? ratio * 100 : ratio;
  return `${percent.toFixed(1).replace('.', ',')} %`;
}
